import { FEATURE_NAME } from "../common/features";

export const MODULE_ROUTE = {
  // App Info
  [FEATURE_NAME.DASHBOARD]: "/dashboard",
  // User
  [FEATURE_NAME.USER_MANAGEMENT]: "/user/management",
  [FEATURE_NAME.EMPLOYEE]: "/employee/list",
  [FEATURE_NAME.EMPLOYER]: "/employer/list",
  [FEATURE_NAME.COMPANY_LIST] : "/company/list",
  [FEATURE_NAME.BILLING_LIST] : "/billing/list",

  // payroll
  [FEATURE_NAME.PAYROLL_ADVANCE_LIST]: "/payroll/list",

  //user
  [FEATURE_NAME.BULK_CREATE_EMPLOYEE]: "/employee/create/bulk",
  [FEATURE_NAME.PROFILE]: "/profile",
};

export const MODULE_ROUTE_TITLE = {
  // App Info
  [MODULE_ROUTE.DASHBOARD]: "Dashboard",
  [MODULE_ROUTE.EMPLOYEE]: "Employee List",
  [MODULE_ROUTE.BULK_CREATE_EMPLOYEE]: "Employee List",
  [MODULE_ROUTE.PAYROLL_ADVANCE_LIST]: "Payroll Advance List",
  [MODULE_ROUTE.PROFILE]: "My Profile",
  [MODULE_ROUTE.EMPLOYER]: "Employer List",
  [MODULE_ROUTE.COMPANY_LIST]: "Company List",
  [MODULE_ROUTE.BILLING_LIST]: "Billing List",
};

export const MODULE_ROUTE_BY_PATH = Object.fromEntries(
  Object.entries(MODULE_ROUTE).map(([key, value]) => [value, key])
);

export const MODULE_ROUTE_FEATURE_TITLE_BY_PATH = Object.fromEntries(
  Object.entries(MODULE_ROUTE).map(([key, value]) => [
    value,
    MODULE_ROUTE_TITLE[key],
  ])
);